import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { terminateTokens } from "../../api/utils/localStorage";
import { logout } from "../shared/slices/authSlice";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { Routes } from "../../routes-config";

const MsalLogout = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(logout());
    terminateTokens();
    history.push(Routes.STAFF_LOGIN);
  }, []);
  return <div />;
};
export default MsalLogout;
